<template>
	<div class="oh allchain">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="index_block  whitebox oh right_topbox" style="min-height: 760px;">

					<div class="morechainenlist1">

						<div class="notionenlist" v-for="(list, index) in enterlist" :key="index"
							v-show="list.list.length > 0">
							<h4 class="title oh"><span class="fl fwb">{{ title }}-</span><span
									class="fl">{{ typelist[index].name }}</span><span class="focuslink fr"
									@click="tagrouter('/targetEnterprise', type, 'notion', notioncode, title)">全国同行企业></span>
							</h4>
							<div class="oh">
								<span class="a-router" v-for="(item, ind) in list.list" :key="'s' + ind"
									@click="routerlinkid('/enterprises', item.stockCode)">{{ item.title }}</span>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'chainEnterpriselist',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			typelist: [{ id: 9, name: '上市公司', children: [], }, { id: 1, name: '龙头企业', children: [], }, { id: 2, name: '创新企业', children: [], }, { id: 3, name: '优质企业', children: [], }],
			notioncode: "", title: "", type: 1, ajaxurls: '',
			enterlist: [],
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
		this.notioncode = this.$route.query.code;
		this.title = this.$route.query.title;
		this.type = this.$route.query.type ? this.$route.query.type : 0;
		// console.log(this.userdata.city,this.userdata.city>100 && this.userdata.city<10000) 
	},
	mounted() {
		this.bus.$emit('loading', true);
		this.ajaxurls = this.$api.cyl.notion.chainenterprisedetail() + '?notionCode=' + this.notioncode + '&areaId=' + this.userdata.city;
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getpagedata();
	},
	methods: {
		getpagedata(type, step) {
			var _this = this;
			var ajaxurld = this.ajaxurls;
			console.log(ajaxurld);
			this.$axios.get(ajaxurld, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('企业列表', res.data);
				_this.enterlist = res.data.list;
				document.title = _this.title;
				_this.bus.$emit('loading', false);
			}).catch(function (error) { });


		}



	},
}
</script>

<style></style>
